import styled, { keyframes } from 'styled-components';

export const fadeOut = keyframes`
    from {
    opacity: 90%;
  }
    to {
    opacity: 0;
  }
`;

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  position: relative;
  width: 100%;
`;

export const FadeOverlay = styled.div`
  animation: ${fadeOut} 1.2s ease-in-out forwards;
  background: ${({ theme }) => theme.elsie.colors.canvas.soft};
  inset: 0;
  pointer-events: none;
  position: absolute;
  z-index: 2;
`;

export const Content = styled.section`
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: space-between;
  margin-top: 20px;
`;

export const InfoWrapper = styled.section`
  background-color: ${({ theme }) => theme.elsie.colors.canvas.subtle};
  border: ${({ theme }) => theme.elsie.borderWidth.sm} solid ${({ theme }) => theme.elsie.colors.border.subtle};
  border-radius: ${({ theme }) => theme.elsie.borderRadius.lg};
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.08);
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 410px;
  overflow: hidden;
  padding: 12px 20px;
`;

export const TabTitle = styled.h3`
  align-self: center;
  color: ${({ theme }) => theme.elsie.colors.content.subtle};
  font-size: ${({ theme }) => theme.elsie.fontSize.md};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  letter-spacing: 0.32px;
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 20px 0;
  width: 98%;
`;

export const InfoTitle = styled.h4`
  color: ${({ theme }) => theme.elsie.colors.content.subtle};
  font-size: ${({ theme }) => theme.elsie.fontSize['2xs']};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 4px 0;
  text-transform: uppercase;
`;

export const Divider = styled.div`
  background-color: ${({ theme }) => theme.elsie.colors.border.subtle};
  height: 1px;
  margin-top: ${({ theme }) => theme.elsie.dimension[16]};
  width: 100%;
`;
